import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Typography from "@mui/material/Typography";
import { appThemeColors, appThemeScrollbar } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeSize } from "styles/appThemeTokens";

const uiFont = appThemeFonts.family.ui;

export const commonTableColWidthSx = [
  { width: "30%", minWidth: 0 },
  { width: "45%", minWidth: 0 },
  { width: "25%", minWidth: 0 },
];

export const CommonTable = styled(Table)({
  borderCollapse: "collapse",
  backgroundColor: appThemeColors.background.paper,
  width: "100%",
  maxWidth: "100%",
  tableLayout: "fixed",
  fontFamily: uiFont,
  boxShadow: "none",
  backgroundImage: "none",
});

export const CommonTableContainer = styled(TableContainer)({
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  overflow: "auto",
  backgroundColor: appThemeColors.background.paper,
  fontFamily: uiFont,
  boxShadow: "none",
  backgroundImage: "none",
  ...appThemeScrollbar,
  "& table": {
    border: "none !important",
    borderRadius: "0 !important",
    boxShadow: "none",
    backgroundImage: "none",
  },
  "& thead, & tbody, & tfoot, & tr, & th, & td": {
    border: "none !important",
    fontFamily: "inherit",
  },
  "& .MuiTableHead-root .MuiTableRow-root": {
    backgroundColor: appThemeColors.background.paper2,
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: appThemeColors.background.paper2,
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    minHeight: appThemeSize.tableRowHeight,
    backgroundColor: appThemeColors.background.paper,
  },
  "& .MuiTableBody-root .MuiTableCell-root": {
    fontFamily: uiFont,
    fontSize: `${appThemeFonts.size.base} !important`,
    borderBottom: `1px solid ${appThemeColors.background.soft} !important`,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: "16px",
    paddingRight: "11px",
    height: appThemeSize.tableRowHeight,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    verticalAlign: "middle",
    backgroundColor: appThemeColors.background.paper,
    minWidth: 0,
  },
});

export const CommonTableHeaderCell = styled(TableCell)({
  minWidth: 0,
  fontFamily: uiFont,
  fontWeight: 600,
  fontSize: appThemeFonts.size.sm,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  color: appThemeColors.text.muted,
  backgroundColor: appThemeColors.background.paper2,
  whiteSpace: "nowrap",
  lineHeight: 1.2,
  verticalAlign: "middle",
  height: appThemeSize.tableHeaderMinHeight,
  padding: "10px 16px 8px",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const CommonTableEmptyText = styled(Typography)({
  paddingTop: 24,
  paddingBottom: 24,
  fontSize: appThemeFonts.size.base,
  fontFamily: uiFont,
  color: appThemeColors.text.muted,
});

export const commonTableKeyCellSx = {
  fontSize: appThemeFonts.size.base,
  color: appThemeColors.text.primary,
};

export const commonTableValueCellSx = {
  fontSize: appThemeFonts.size.base,
  color: appThemeColors.text.muted,
};

export const commonTableDetailPaperSx = {
  overflow: "hidden",
};

export const commonTableRoundedPanelContainerSx = {
  overflow: "hidden",
  border: "none",
  boxShadow: "none",
  backgroundImage: "none",
  borderBottomLeftRadius: "14px",
  borderBottomRightRadius: "14px",
  "& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root": {
    borderBottom: "none !important",
  },
};
